import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from './views/Home.vue';
import Messages from './views/Messages.vue';

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'home',
		component: Home
	},
	{
		path: '/messages',
		name: 'messages',
		component: Messages
	},
	{
		path: '*',
		name: '404',
		component: Home
	},
//   {
//     path: '/about',
//     name: 'about',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
//   }
]

const router = new VueRouter({
	mode:"history",
	base:"/",
	routes
})

export default router
